export default __webpack_public_path__ + "static/media/logo.045b01d9.png";